export default "__VITE_ASSET__Cah9rqYt__"